import React from "react";

function InputField(
  props: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >
) {
  return (
    <input
      {...props}
      className={`w-full px-3 py-2 rounded-xl outline-none border border-slate-200 dark:border-white/10 bg-white dark:bg-[#1a1e2d] text-slate-800 dark:text-slate-100 placeholder-slate-400 focus:border-purple-500/50 focus:ring-1 focus:ring-purple-500/30 transition-all text-xs ${
        props.className || ""
      }`}
    />
  );
}

export default InputField;